import axios from 'axios'
import { baseUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 租户策略查询接口
export function tenantList() {
  const url = baseUrl + '/tenant/tactics/list'

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备设置', '租户设备策略查询', res)
    }
    return Promise.resolve(res.data)
  })
}

// 租户策略更新接口
export function tenantUpdate(params) {
  const url = baseUrl + '/tenant/tactics/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备设置', '租户设备策略更新', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询租户自定义系统名称、图标等
export function tenantSysConfig() {
  const url = baseUrl + '/tenant/config/sys/find'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('基础配置', '查询租户自定义系统名称、图标', res)
    }
    return Promise.resolve(res.data)
  })
}
